import React, { useState, useEffect } from 'react'
import { View, TouchableOpacity, Animated, Easing, Dimensions, Platform } from 'react-native'
import PropTypes from 'prop-types'
import moment from 'moment'
import WebView from 'react-native-webview'

import { VFText, Icon, QuickActionMenu } from '@vfgroup-oneplatform/foundation/Components'
import { useTheme, Images } from '@vfgroup-oneplatform/foundation/Components/Themes'

import ContentManager from '@vfgroup-oneplatform/foundation/ContentManager'

import Loading from '../Loading'

import styles from './TotalCost.Styles'

const { height: SCREEN_HEIGHT } = Dimensions.get('window')
import Modal from 'react-native-modal'


const TotalCost = ({ offer, renderButton }) => {

  const theme = useTheme()

  const startDate = moment(moment().add(1, 'days')).format('DD/MM/YYYY')

  const [isOpened, setIsOpended] = useState(false)

  const [modalState, setModalState] = useState({ isVisible: false, title: '', url: '' })

  const rotate = new Animated.Value(0)

  const rotateValue = rotate.interpolate({
    inputRange: [0, 1],
    outputRange: ['0deg', '-180deg']
  })

  useEffect(() => {
    Animated.timing(rotate, {
      toValue: isOpened ? 1 : 0,
      duration: 200,
      easing: Easing.linear,
      useNativeDriver: true
    }).start()
    console.log()

  }, [isOpened, setIsOpended, rotateValue])

  const openModal = (title, url) => {
    setModalState(prev => ({
      ...prev,
      isVisible: true,
      title: title,
      url: ContentManager.translate(url)
    }))
  }

  const closeModal = () => {
    setModalState(prev => ({
      ...prev,
      isVisible: false,
      title: '',
      url: ''
    }))
  }

  const renderModals = () => {
    if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
      return (
        <Modal
          isVisible={modalState.isVisible}
          backdropOpacity={0.5}
          onSwipeComplete={closeModal}
          onBackdropPress={closeModal}
          propagateSwipe
          hideModalContentWhileAnimating
          hardwareAccelerated
          backdropTransitionOutTiming={0}
          style={{
            justifyContent: 'flex-end',
            margin: '0 !important',
            minWidth: 1920,
            maxWidth: 1920,
          }}
        >
          <View
            style={{
              minWidth: '600px',
              maxWidth: '600px',
              height: 'auto',
              backgroundColor: theme.colors.backgroundColor,
              margin: 'auto',
              padding: '20px',
              paddingTop: null,
              borderRadius: "7px",
            }}
            onStartShouldSetResponder={() => true}>
            <WebView
              source={{ uri: modalState?.url }}
              startInLoadingState={true}
              showsVerticalScrollIndicator={false}
              renderLoading={() => {
                return (
                  <View style={{ height: SCREEN_HEIGHT / 1.75 }} >
                    <Loading theme={theme} />
                  </View>)
              }}
            />
          </View>
        </Modal>
      )
    } else {
      return (
        <QuickActionMenu
          isVisible={modalState.isVisible}
          title={modalState.title}
          type='secondary'
          toggleModal={closeModal}
          titleStyle={styles.titleStyle}
          closeBtnStyle={styles.buttonStyle}
          contentContainerStyle={{ paddingTop: 20 }}
        >
          <View
            onStartShouldSetResponder={() => true}
            style={{ height: SCREEN_HEIGHT / 1.75, paddingTop: 10 }}
          >
            <WebView
              source={{ uri: modalState?.url }}
              startInLoadingState={true}
              renderLoading={() => {
                return (
                  <View style={{ height: SCREEN_HEIGHT / 1.75 }} >
                    <Loading theme={theme} />
                  </View>)
              }}
            />
          </View>
        </QuickActionMenu>
      )
    }
  }


  return (
    <>
      <View style={styles.container(theme)}>
        <VFText
          i18nKey='acquisition_total_cost'
          style={styles.title}
        />
        <VFText
          i18nKey='acquisition_total_cost_subtitle'
          style={styles.subtitle(theme)}
        />

        <View style={[styles.row, styles.borderBottom(theme)]} >
          <VFText
            i18nKey={offer.price}
            style={styles.title}
          />
          {offer?.isMonthly && <VFText
            i18nKey='acquisition_monthly'
            style={styles.subtitle(theme)}
          />}
        </View>

        <View style={styles.rowContainer} >
          <VFText
            i18nKey='acquisition_start_date'
            style={styles.valueDesc}
          />
          <VFText
            i18nKey={startDate}
            style={styles.valueText}
          />
        </View>

        {offer?.contractDuration?.amount && <View style={[styles.rowContainer, styles.borderBottom(theme)]} >
          <VFText
            i18nKey='acquisition_contract_duration'
            style={styles.valueDesc}
          />
          <VFText
            i18nKey={offer?.contractDuration?.amount === 1 ? 'acquisition_contract_duration_value_one' : 'acquisition_contract_duration_value'}
            placeHolders={[offer?.contractDuration?.amount?.toString()]}
            style={styles.valueText}
          />
        </View>}

        <View style={[styles.rowContainer, styles.borderBottom(theme)]} >
          <VFText
            i18nKey='acquisition_plan_monthly_cost'
            style={styles.valueDesc}
          />
          <VFText
            i18nKey={offer.price}
            style={styles.valueText}
          />
        </View>

        <View style={[styles.rowContainer, styles.borderBottom(theme)]} >
          <VFText
            i18nKey='acquisition_plan_breakdown'
            style={styles.valueDesc}
          />
          <TouchableOpacity onPress={() => setIsOpended(prev => !prev)} >
            <Animated.View style={{ transform: [{ rotate: rotateValue }] }}>
              <Icon
                name={Images.ic_chevron_down_red}
                size={25}
                resizeMode="contain"

              />
            </Animated.View>
          </TouchableOpacity>
        </View>

        {isOpened && <View>
          <VFText
            i18nKey='acquisition_breakdown_title'
            style={styles.breakdownTitle}
          />
          <View style={styles.breakdownContainer(theme)}>
            <VFText
              i18nKey={offer.title}
              style={styles.valueText}
            />
            <View style={[styles.rowContainer, { marginTop: 15 }]} >
              <VFText
                i18nKey='acquisition_plan_monthly_cost'
                style={styles.valueDesc}
              />
              <VFText
                i18nKey={offer?.price}
                style={styles.valueText}
              />
            </View>

            {offer?.addon && <View style={styles.rowContainer} >
              <VFText
                i18nKey='acquisition_plan_bonus'
                style={styles.valueDesc}
              />
              <VFText
                i18nKey={offer?.addon?.name}
                style={styles.valueText}
              />
            </View>}
          </View>
        </View>}


        <View style={styles.termsContainer}>
          <View style={styles.termsTextContainer}>
            <VFText
              i18nKey="acquisition_terms"
              style={styles.text}
            />
            <TouchableOpacity onPress={() => openModal('acquisition_terms_modal_title', 'acquisition_terms_url')} >
              <VFText
                i18nKey="acquisition_terms_link"
                style={styles.underline}
              />
            </TouchableOpacity>

          </View>
          {/* <View style={styles.termsTextContainer}>
            <VFText
              i18nKey="acquisition_policy"
              style={styles.text}
            />
            <TouchableOpacity onPress={() => openModal('acquisition_policy_modal_title', 'acquisition_policy_url')} >
              <VFText
                i18nKey="acquisition_policy_link"
                style={styles.underline}
              />
            </TouchableOpacity>
          </View> */}
        </View>

        {renderButton && renderButton()}
        {renderModals()}

      </View>
      {/* <QuickActionMenu
        isVisible={modalState.isVisible}
        title={modalState.title}
        type='secondary'
        toggleModal={closeModal}
        titleStyle={styles.titleStyle}
        closeBtnStyle={styles.buttonStyle}
        contentContainerStyle={{ paddingTop: 20 }}
      >
        <View
          onStartShouldSetResponder={() => true}
          style={{ height: SCREEN_HEIGHT / 1.75, paddingTop: 10 }}
        >
          <WebView
            source={{ uri: modalState?.url }}
            startInLoadingState={true}
            renderLoading={() => {
              return (
                <View style={{ height: SCREEN_HEIGHT / 1.75 }} >
                  <Loading theme={theme} />
                </View>)
            }}
          />
        </View>
      </QuickActionMenu> */}
    </>
  )
}
TotalCost.propTypes = {
  offer: PropTypes.object,
  renderButton: PropTypes.func,
}

export default TotalCost
